module.exports = __webpack_public_path__ + "img/pageBanner-trafficInformation.0cc80158.jpg";